import { Component, OnInit } from '@angular/core';
import { AgnoskojService } from './../../services/agnoskoj/agnoskoj.service';
import { SeoService } from './../../services/seo.service';


@Component({
  selector: 'app-agnoskoj',
  templateUrl: './agnoskoj.component.html',
  styleUrls: ['./agnoskoj.component.scss']
})
export class AgnoskojComponent implements OnInit {

  agnoskoj: any;
  categories = [
    {
      title: 'departamentos'
    },
    {
      title: 'municipios'
    },
    {
      title: 'ciudades'
    }
  ];

  message = false;

  yearActive;
  categoryActive;
  mains;
  others;
  mainsActive;


  constructor(
    private agnoskojService: AgnoskojService,
    private seoService: SeoService
  ) {
    this.seoService.setTagsPage({
      title: 'Cptur | Reconocimientos',
      type: 'website',
      description: 'Reconocimientos',
      image: '/assets/images/logo.png'
    });
  }

  ngOnInit() {
    this.getAgnoskoj();



  }

  getAgnoskoj() {
    this.agnoskojService.getAgnoskoj().subscribe(agnoskoj => {

      agnoskoj.reverse();

      this.agnoskoj = agnoskoj;

      this.setYear(this.agnoskoj[0]);
      // this.setCategory(this.categories[0]);

    })
  }

  setYear(year) {
    this.yearActive = year;

    this.setCategory(this.categories[0]);
  }

  setCategory(category) {
    this.categoryActive = category;


    if (this.categoryActive.title == 'departamentos') {
      if (this.yearActive.deptos == null) {
        this.message = true;
      } else {


        this.mains = this.yearActive.deptos.mains;
        this.others = this.yearActive.deptos.others;
        this.message = false;

      }

    } else if (this.categoryActive.title == 'municipios') {
      if (this.yearActive.municipalities == null) {
        this.message = true;
      } else {
        this.mains = this.yearActive.municipalities.mains;
        this.others = this.yearActive.municipalities.others;
        this.message = false;
      }
    } else if (this.categoryActive.title == 'ciudades') {
      if (this.yearActive.cities == null) {
        this.message = true;
      } else {
        this.mains = this.yearActive.cities.mains;
        this.others = this.yearActive.cities.others;
        this.message = false;
      }
    } else {
      this.message = true;
    }

    if (this.mains == null) {
      this.message = true;
    }


    if (this.mains && !this.message) {
      this.setRecognitionViewActive(this.mains[0]);
    }


  }

  setRecognitionViewActive(item) {
    this.mainsActive = item;
  }





}
